import React from "react"
import PropTypes from "prop-types"
import { Card, CardBody, CardTitle, Table } from "reactstrap"
import { formatearNumero } from "helpers/formatters"
import { formatearDuracion, infoEstadoPaso } from "./migracionEstadoHelpers"
import { derivarResumenPorPasos } from "./resumenPasos"

/**
 * «Resumen por pasos»: una fila por nivel (Productores, Establecimientos, ARCA,
 * Siembras, Ganadería, Tambo) con estado, duración y conteos por categoría
 * cerrada. «No ejecutado» se deriva de `parametros.niveles` (solo corridas por
 * niveles). Sin estado o sin pasos no muestra nada.
 *
 * `filas` permite pasar el resumen ya derivado (el Historial lo necesita
 * también para decidir qué secciones mostrar).
 */
const ResumenPorPasos = ({ estado, filas, conCard = true }) => {
  const resumen = filas || derivarResumenPorPasos(estado)
  if (!resumen.length) return null
  const tabla = (
    <Table
      size="sm"
      responsive
      className="mb-0"
      data-testid="resumen-por-pasos"
    >
      <thead className="table-light">
        <tr>
          <th>Nivel</th>
          <th>Estado</th>
          <th>Duración</th>
          <th>Conteos</th>
        </tr>
      </thead>
      <tbody>
        {resumen.map(f => {
          const info = infoEstadoPaso(f.estado)
          return (
            <tr key={f.nivel} data-testid={`resumen-fila-${f.nivel}`}>
              <td>
                <strong>{f.etiqueta}</strong>
              </td>
              <td>
                <span
                  className={info.color}
                  data-testid={`resumen-estado-${f.nivel}`}
                >
                  <i className={`mdi ${info.icono} me-1`} aria-hidden="true" />
                  {info.texto}
                </span>
                {f.estado === "OMITIDO" && f.motivoOmision && (
                  <small className="text-muted d-block">
                    {f.motivoOmision}
                  </small>
                )}
              </td>
              <td data-testid={`resumen-duracion-${f.nivel}`}>
                {formatearDuracion(f.duracionSeg)}
              </td>
              <td className="small">
                {f.conteos.length > 0
                  ? f.conteos
                      .map(c => `${c.etiqueta}: ${formatearNumero(c.valor, 0)}`)
                      .join(" · ")
                  : "-"}
              </td>
            </tr>
          )
        })}
      </tbody>
    </Table>
  )
  if (!conCard) return tabla
  return (
    <Card className="mb-3" data-testid="seccion-resumen-por-pasos">
      <CardBody>
        <CardTitle tag="h6">
          <i className="mdi mdi-format-list-checks me-2" />
          Resumen por pasos
        </CardTitle>
        {tabla}
      </CardBody>
    </Card>
  )
}

ResumenPorPasos.propTypes = {
  estado: PropTypes.object,
  filas: PropTypes.array,
  conCard: PropTypes.bool,
}

export default ResumenPorPasos
